<div class="modal-header">
  <h4 class="modal-title pull-left">{{'ROCK_TYPE.ROCK_TYPE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="close()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>

</div>
<div class="modal-body">
  <div class="modal-content">
    <form id="ngForm" #ngForm="ngForm"  (ngSubmit)="onSubmit()">
      <div class="flex-col">
        <div class="form-group two-col-item">
          <label for="name">{{'GLOBAL.NOM' | translate}}</label>
          <input  [(ngModel)]="selectedRockType.name"  id="name" #name="ngModel" type="text" name="name" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" [ngClass]="{'error-value': name.errors?.required  && showError()}" maxlength="150" autocomplete="off" required />
        </div>

        <div class="form-group  two-col-item">
          <label for="density">{{'ROCK_TYPE.DENSITY' | translate}}: (kg/m3)</label>
          <input [(ngModel)]="selectedRockType.density" id="density" type="number" #density="ngModel" name="density" class="form-control" [ngClass]="{'error-value': density.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.DENSITY' | translate}}"  autocomplete="off" required />
        </div>
      </div>

      <div class="flex-col">
        <div class="form-group  two-col-item">
          <label for="compressiveStrength">{{'ROCK_TYPE.COMPRESSIVE_STRENGTH' | translate}}: (MPa)</label>
          <input [(ngModel)]="selectedRockType.compressiveStrength" id="compressiveStrength" type="number" #compressiveStrength="ngModel" name="compressiveStrength" class="form-control" [ngClass]="{'error-value': compressiveStrength.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.COMPRESSIVE_STRENGTH' | translate}}"  autocomplete="off"  />
        </div>
        <div class="form-group two-col-item">
          <label for="shearModulus">{{'ROCK_TYPE.SHEAR_MODULUS' | translate}}: (MPa)</label>
          <input  [(ngModel)]="selectedRockType.shearModulus" id="shearModulus" type="number" #shearModulus="ngModel" name="shearModulus" class="form-control" [ngClass]="{'error-value': shearModulus.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.SHEAR_MODULUS' | translate}}"autocomplete="off"  />
        </div>
      </div>

      <div class="flex-col">
        <div class="form-group  two-col-item">
          <label for="youngModulus">{{'ROCK_TYPE.YOUNG_MODULUS' | translate}}: (GPa)</label>
          <input [(ngModel)]="selectedRockType.youngModulus" id="youngModulus" type="number" #youngModulus="ngModel" name="youngModulus" class="form-control" [ngClass]="{'error-value': youngModulus.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.YOUNG_MODULUS' | translate}}"  autocomplete="off"  />
        </div>

        <div class="form-group two-col-item">
          <label for="poissonRatio">{{'ROCK_TYPE.POISSON_RATIO' | translate}}</label>
          <input  [(ngModel)]="selectedRockType.poissonRatio" id="poissonRatio" type="number" #poissonRatio="ngModel" name="length" class="form-control" [ngClass]="{'error-value': poissonRatio.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.POISSON_RATIO' | translate}}"autocomplete="off"  />
        </div>
      </div>

      <div class="flex-col">
        <div class="form-group  two-col-item">
          <label for="theoreticalSpeed">{{'ROCK_TYPE.THEORETICAL_SPEED' | translate}}: (km/s)</label>
          <input [(ngModel)]="selectedRockType.theoreticalSpeed" id="theoreticalSpeed" type="number" #theoreticalSpeed="ngModel" name="theoreticalSpeed" class="form-control" [ngClass]="{'error-value': theoreticalSpeed.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.THEORETICAL_SPEED' | translate}}"  autocomplete="off"  />
        </div>

        <div class="form-group two-col-item">
          <label for="rqd">{{'ROCK_TYPE.RQD_FULLNAME' | translate}}</label>
          <input  [(ngModel)]="selectedRockType.rqd" id="length" type="number" #rqd="ngModel" name="rqd" class="form-control" [ngClass]="{'error-value': rqd.errors?.required  && showError()}" placeholder="{{'ROCK_TYPE.RQD_FULLNAME' | translate}}"autocomplete="off"  />
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group" role="group">
    <button form="ngForm" type="submit"  class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>

  </div>
  <div class="btn-group" role="group">
    @if (isModif) {
      <button class="btn btn-outline-danger " style="margin-right:0.25rem;" (click)="delete()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
    }
    <button type="button" class="btn btn-secondary" (click)="close()">{{'GLOBAL.FERMER' | translate}}</button>
  </div>
</div>


